module.exports = __webpack_public_path__ + "img/vi.b65c93f4.png";